import React, { useState } from "react";
import {
  SFStack,
  SFTypography,
  SFUseStyled,
  SFAccordion,
  SFAccordionSummary,
  SFAccordionDetails,
  SFIconButton,
  SFIcons,
} from "@sf-core";
import { useTranslation } from "react-i18next";
import SkillPathItem from "./skillPathItem";
import GroupInfoDialog from "./groupInfoDialog";

const { styled } = SFUseStyled();

const StyledAccordion = styled(SFAccordion)(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, 0)",
  paddingTop: theme.spacing(1),
  marginTop: "0px !important",
}));

const SFAccordionSummaryStyled = styled(SFAccordionSummary)(({ theme }) => ({
  backgroundColor: "rgba(196, 196, 205, 0.1)",
  borderRadius: theme.spacing(1),
  flexDirection: "row-reverse",
  paddingLeft: theme.spacing(1),
  height: "40px !important",
  minHeight: "40px !important",
  "& .MuiAccordionSummary-content": {
    pointerEvents: "none",
  },
  "& .MuiButtonBase-root": {
    pointerEvents: "auto",
  },
}));

const SFAccordionDetailsStyled = styled(SFAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0),
  color: "white !important",
  "& .skill-wrapper": {
    padding: theme.spacing(2, 0),
  },
}));

const StyledStack = styled(SFStack)(({ theme }) => ({
  height: "100%",
  paddingLeft: theme.spacing(1),
}));

const SkillPathGroup = ({
  skillPaths,
  descriptionLines,
  skillPathLevelId,
  defaultExpanded = true,
  isUpSkillingGroup = false,
}) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const [groupDialog, setGroupDialog] = useState({ open: false });

  let accordionTitle = t("skillPathsGrouping.refreshKnowledge.label");
  if (isUpSkillingGroup)
    accordionTitle = t("skillPathsGrouping.upSkilling.label");

  const handeOpenGroupDialog = () => {
    //Find the unique skills for all the group skillPaths
    const groupSkills = skillPaths.reduce((accumulator, course) => {
      course.skills.forEach((skill) => {
        if (!accumulator.some((accSkill) => accSkill.id === skill.id)) {
          accumulator.push(skill);
        }
      });
      return accumulator;
    }, []);

    setGroupDialog({
      open: true,
      title: isUpSkillingGroup
        ? t("skillPathsGrouping.upSkilling.popupTitle")
        : t("skillPathsGrouping.refreshKnowledge.popupTitle"),
      description: isUpSkillingGroup
        ? t("skillPathsGrouping.upSkilling.popupDescription")
        : t("skillPathsGrouping.refreshKnowledge.popupDescription"),
      skills: groupSkills,
      closeButton: t("skillPathsGrouping.popupCloseBtn"),
      label: t("skillPathsGrouping.popupLabel"),
    });
  };

  return (
    <>
      <GroupInfoDialog
        groupDialog={groupDialog}
        setGroupDialog={setGroupDialog}
        onClose={() => setGroupDialog({ open: false })}
        skillPathId={skillPathLevelId}
      />
      {skillPaths?.length > 0 && (
        <StyledAccordion
          expanded={expanded}
          onChange={() => setExpanded(!expanded)}
        >
          <SFAccordionSummaryStyled>
            <StyledStack direction="row" alignItems="center">
              <SFTypography variant="body1">{accordionTitle}</SFTypography>
              <SFIconButton
                onClick={(event) => {
                  event.stopPropagation();
                  handeOpenGroupDialog();
                }}
                variant="transparent"
              >
                <SFIcons.SFInfoIcon size="small" />
              </SFIconButton>
            </StyledStack>
          </SFAccordionSummaryStyled>
          <SFAccordionDetailsStyled>
            <div className="details-wrapper">
              {skillPaths?.map((item, index) => (
                <div className="skill-wrapper" key={index}>
                  <SkillPathItem
                    key={index}
                    skillPath={item}
                    skillPathLevelId={skillPathLevelId}
                    descriptionLines={descriptionLines}
                  />
                </div>
              ))}
            </div>
          </SFAccordionDetailsStyled>
        </StyledAccordion>
      )}
    </>
  );
};

export default SkillPathGroup;
